/**
 * Web: тактильной отдачи нет (стори 3.1). Настоящий пакет тянет `expo-modules-core` с
 * TS-синтаксисом, который webpack в этой сборке не разбирает, — тот же случай, что у
 * `expo-media-library`.
 *
 * Vibration API в браузерах формально существует, но на десктопе его нет вовсе, а в мобильных
 * браузерах он даёт грубое дребезжание вместо тактильного отклика — это хуже, чем тишина.
 * Поэтому здесь честный no-op, а не эмуляция.
 */

export enum ImpactFeedbackStyle {
  Light = 'light',
  Medium = 'medium',
  Heavy = 'heavy',
}

export enum NotificationFeedbackType {
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
}

export async function impactAsync(_style?: ImpactFeedbackStyle): Promise<void> {}

export async function notificationAsync(_type?: NotificationFeedbackType): Promise<void> {}

export async function selectionAsync(): Promise<void> {}
